import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';

import { esPeticionDeAcceso } from '@app/domain/auth/peticion-de-acceso';
import { SesionTerminadaService } from './sesion-terminada.service';

/**
 * Una sola responsabilidad: con la sesión terminada, no mandar a la red nada que
 * no sea del trámite de acceso (feature 33, R4/R5). Cada petición saldría con el
 * token que el back ya rechazó y volvería rechazada.
 *
 * `EMPTY` y no un error: un error llegaría a los `error:` de las pantallas y
 * varias abren su propio aviso — se cambiarían N avisos globales por N locales.
 *
 * Se registra con `withInterceptors` ANTES de `withInterceptorsFromDi()`, así que
 * queda por fuera de `ApiKeyInterceptor` y `authInterceptor`: la petición cortada
 * no llega ni a firmarse.
 */
export const sesionTerminadaInterceptor: HttpInterceptorFn = (req, next) => {
  const sesionTerminada = inject(SesionTerminadaService);
  return sesionTerminada.activa() && !esPeticionDeAcceso(req.url) ? EMPTY : next(req);
};
